import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '4vh',
    [theme.breakpoints.down('xl')]: {
      marginTop: '1vh',
    },
    '& .MuiFormControlLabel-label': {
      textAlign: 'left',
      [theme.breakpoints.down('xl')]: {
        fontSize: 'clamp(0.85em, 2em, 0.85em)',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(0.7em, 2em, 0.85em)',
      },
    },
  },
  btnWrapper: {
    marginTop: '6vh',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1vh',
    },
  },
  formTitle: {
    fontWeight: '500',
    color: theme.palette.other.dark,
    textAlign: 'left',
    [theme.breakpoints.down('xl')]: {
      fontSize: 'clamp(0.9em, 2em, 0.9em)',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px',
      fontSize: 'clamp(0.7em, 2em, 0.85em)',
    },
  },
}))
